import { Stock } from '../models/stock'
import * as stock from '../actions/stock.actions'

export interface State {
    loading: boolean
    error: any
    stock: { [id: string]: Stock }
}

const intialState = {
    loading: false,
    error: null,
    stock: {}
}

export function reducer(
    state = intialState,
    action: stock.Actions
) {
    switch(action.type) {
        case stock.GET:
            return {
                ...state,
                loading: true
            }
        case stock.GET_SUCCESS:
            return {
                ...state,
                loading: false,
                stock: action.payload.reduce(
                    (dict, stock) => Object.assign(dict, {
                        [stock.productcode]: stock
                    }), {})
            }

        case stock.GET_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state
    }
}

export const isLoading = (state: State) => state.loading
export const getStock = (state: State) => state.stock
export const getError = (state: State) => state.error